import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-shipment',
  templateUrl: './terms-and-conditions-shipment.component.html',
  styleUrls: ['./terms-and-conditions-shipment.component.scss'],
})
export class TermsAndConditionsShipmentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
